// FETCH ALL PRINTING2 INWARD DETAILS
export const FETCH_PRINTING2_INWARD_DETAILS_REQUEST_DK = 'FETCH_PRINTING2_INWARD_DETAILS_REQUEST_DK';
export const FETCH_PRINTING2_INWARD_DETAILS_SUCCESS_DK = 'FETCH_PRINTING2_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_PRINTING2_INWARD_DETAILS_FAILURE_DK = 'FETCH_PRINTING2_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL PRINTING2 INWARD DETAILS
export const FETCH_PRINTING2_INWARD_DETAILS_WITHOUT_ID_REQUEST_DK = 'FETCH_PRINTING2_INWARD_DETAILS_WITHOUT_ID_REQUEST_DK';
export const FETCH_PRINTING2_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK = 'FETCH_PRINTING2_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK';
export const FETCH_PRINTING2_INWARD_DETAILS_WITHOUT_ID_FAILURE_DK = 'FETCH_PRINTING2_INWARD_DETAILS_WITHOUT_ID_FAILURE_DK';

// CREATE PRINTING2 INWARD DETAILS
export const CREATE_PRINTING2_INWARD_DETAILS_REQUEST_DK = 'CREATE_PRINTING2_INWARD_DETAILS_REQUEST_DK';
export const CREATE_PRINTING2_INWARD_DETAILS_SUCCESS_DK = 'CREATE_PRINTING2_INWARD_DETAILS_SUCCESS_DK';
export const CREATE_PRINTING2_INWARD_DETAILS_FAILURE_DK = 'CREATE_PRINTING2_INWARD_DETAILS_FAILURE_DK';

// UPDATE PRINTING2 INWARD DETAILS
export const UPDATE_PRINTING2_INWARD_DETAILS_REQUEST_DK = 'UPDATE_PRINTING2_INWARD_DETAILS_REQUEST_DK';
export const UPDATE_PRINTING2_INWARD_DETAILS_SUCCESS_DK = 'UPDATE_PRINTING2_INWARD_DETAILS_SUCCESS_DK';
export const UPDATE_PRINTING2_INWARD_DETAILS_FAILURE_DK = 'UPDATE_PRINTING2_INWARD_DETAILS_FAILURE_DK';

// FETCH SINGLE STATE OF PRINTING2 INWARD DETAILS
export const FETCH_SINGLE_PRINTING2_INWARD_DETAILS_REQUEST_DK = 'FETCH_SINGLE_PRINTING2_INWARD_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_PRINTING2_INWARD_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_PRINTING2_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_PRINTING2_INWARD_DETAILS_FAILURE_DK = 'FETCH_SINGLE_PRINTING2_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM PRINTING2_INWARD DETAILS
export const FETCH_PREVIOUS_PRINTING2_INWARD_DETAILS_REQUEST_DK = 'FETCH_PREVIOUS_PRINTING2_INWARD_DETAILS_REQUEST_DK';
export const FETCH_PREVIOUS_PRINTING2_INWARD_DETAILS_SUCCESS_DK = 'FETCH_PREVIOUS_PRINTING2_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_PREVIOUS_PRINTING2_INWARD_DETAILS_FAILURE_DK = 'FETCH_PREVIOUS_PRINTING2_INWARD_DETAILS_FAILURE_DK';

// DELETE PRINTING2 INWARD DETAILS
export const DELETE_PRINTING2_INWARD_DETAILS_REQUEST_DK = 'DELETE_PRINTING2_INWARD_DETAILS_REQUEST_DK';
export const DELETE_PRINTING2_INWARD_DETAILS_SUCCESS_DK = 'DELETE_PRINTING2_INWARD_DETAILS_SUCCESS_DK';
export const DELETE_PRINTING2_INWARD_DETAILS_FAILURE_DK = 'DELETE_PRINTING2_INWARD_DETAILS_FAILURE_DK';

export const RESET_PRINTING2_INWARD_DETAILS_INFO_DK = 'RESET_PRINTING2_INWARD_DETAILS_INFO_DK';

export const CREATE_PRINTING2_INWARD_DETAILS_FORM_DK = 'CREATE_PRINTING2_INWARD_DETAILS_FORM_DK';

export const UPDATE_PRINTING2_INWARD_DETAILS_FORM_DK = 'UPDATE_PRINTING2_INWARD_DETAILS_FORM_DK';
